import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";

export const Create_Agent = (branchid, user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newAgent/${branchid}`,
        { ...user },
        config
      );
      dispatch({
        type: actions.CREATE_AGENT,
        payload: res.data.data,
      });
    } catch (error) {
      Swal.fire({
        title: "OPS",
        text: "تکایە ژمارەی مۆبایلەکەت دووبارەیە ژمارەکی دی بەکاربێنە",
        icon: "error",
        html: `<b class="fk">
          تکایە ژمارەی مۆبایلەکەت دووبارەیە ژمارەکی دی بەکاربێنە 
        )}</b>`,
        confirmButtonText: "Ok",
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
    }
  };
};

export const Get_List_Agents = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAgents`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_LIST_AGENTS,
          payload: res.data.data,
          agent_status: true,
        });
      }
    } catch (error) {}
  };
};

export const Get_Branch_Object = (id) => {
  return (dispatch, getState) => {
    const data = getState().AdminReducer.list_branches.find(
      (el) => el._id === id
    );

    dispatch({
      type: actions.GET_BRANCH_OBJECT,
      payload: data,
    });
  };
};

export const Update_Branch_Name = (id, user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/updateBranch/${id}`,
        { ...user },
        config
      );
      if (res.status === 200) {
        dispatch({
          type: actions.UPDATE_NAME_BRANCH,
          payload: res.data.data,
        });
      }
    } catch (error) {
      toast.error("Update Branch Name Faieled");
    }
  };
};

export const View_Profile_Agent = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAgent/${id}`, config);
      dispatch({
        type: actions.VIEW_EDIT_AGENT,
        payload: { doc: res.data.data, name: res.data.data.branchId.name },
      });
    } catch (error) {}
  };
};

export const Agent_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateAgentStatus/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.UPDATEING_AGENT_STATUS });
    } catch (error) {}
  };
};

export const Update_Agent_Name = (id, user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/updateAgent/${id}`,
        { ...user },
        config
      );
      if (res.status === 200) {
        dispatch({
          type: actions.UPDATE_NAME_AGENT,
          payload: res.data.data,
        });
      }
    } catch (error) {
      toast.error("Update Agent Name Faieled");
    }
  };
};

export const Create_Bounes_Agent = (agentId, user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/PunishBonus/${agentId}`,
        { ...user },
        config
      );
      dispatch({
        type: actions.CREATE_PUNSHED_AGENT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_BouesPunshed_Agents = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/PunishBonuss`, config);
      dispatch({
        type: actions.GET_LIST_AGENTS_PUNSHED,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Bounes_Agent = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/PunishBonus/${id}`, config);
      dispatch({
        type: actions.VIEW_PUNSHED,
        payload: res.data.data,
        agent_name: res.data.data.agentId,
      });
    } catch (error) {}
  };
};

export const Update_Bounes_Agent = (id, agentId, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/PunishBonus/${id}?agentId=${agentId}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.UPDATE_PUNSHED,
        payload: res.data.data.doc,
      });
    } catch (error) {}
  };
};

export const Punshed_Delete = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/PunishBonus/${id}`, config);
      dispatch({ type: actions.DELETE_PUNSHED, id: id });
    } catch (error) {}
  };
};

// Salary Form Actions
export const Create_Salary_Form = (agentId, user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/Salary/${agentId}`,
        { ...user },
        config
      );
      dispatch({
        type: actions.CREATE_FORM_SALARY,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_Salary_Form = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/Salarys`, config);
      dispatch({
        type: actions.GET_LIST_FORM_SALARY,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Salary_Form = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/Salary/${id}`, config);
      dispatch({
        type: actions.VIEW_FORM_SALARY,
        payload: res.data.data,
        agent_name_salary: res.data.data.agentId,
      });
    } catch (error) {}
  };
};

export const Update_Salary_Form = (id, agentId, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/Salary/${id}?agentId=${agentId}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.UPDATE_FORM_SALARY,
        payload: res.data.data.doc,
      });
    } catch (error) {}
  };
};

export const Salary_Form_Delete = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/Salary/${id}`, config);
      dispatch({ type: actions.DELETE_FORM_SALARY, id: id });
    } catch (error) {}
  };
};

// Persentage Form Actions
export const Create_Persentage_Form = (agentId, user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/Comission/${agentId}`,
        { ...user },
        config
      );
      dispatch({
        type: actions.CREATE_FORM_PERSENTAGE,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_Persentage_Form = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/Comissions`, config);
      dispatch({
        type: actions.GET_LIST_FORM_PERSENTAGE,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Persentage_Form = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/Comission/${id}`, config);
      dispatch({
        type: actions.VIEW_FORM_PERSENTAGE,
        payload: res.data.data,
        agent_name_persentage: res.data.data.agentId,
      });
    } catch (error) {}
  };
};

export const Update_Persentage_Form = (id, agentId, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };

    try {
      const res = await Instance.put(
        `/api/v1/Comission/${id}?agentId=${agentId}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.UPDATE_FORM_PERSENTAGE,
        payload: res.data.data.doc,
      });
    } catch (error) {}
  };
};

export const Persentage_Form_Delete = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/Comission/${id}`, config);
      dispatch({ type: actions.DELETE_FORM_PERSENTAGE, id: id });
    } catch (error) {}
  };
};
